import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      setError("Brak session_id w adresie URL. Spróbuj zalogować się ponownie.");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true, state: { user: res.data } });
        toast.success(`Witaj, ${res.data.name || res.data.email}!`);
      } catch (err) {
        const status = err.response?.status;
        const detail =
          err.response?.data?.detail ||
          (status ? `Błąd ${status}` : "Logowanie nie powiodło się — brak odpowiedzi serwera");
        toast.error(detail);
        setError(detail);
      }
    })();
  }, [navigate, setUser]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50 px-4">
        <div
          data-testid="auth-callback-error"
          className="w-full max-w-md border border-zinc-900 bg-white p-10 shadow-[8px_8px_0_0_#18181b]"
        >
          <div className="font-label mb-2">// Błąd logowania</div>
          <h1 className="font-heading font-black text-2xl uppercase tracking-tight mb-4">
            Nie udało się zalogować
          </h1>
          <p
            data-testid="auth-callback-error-detail"
            className="text-sm text-zinc-700 mb-6 leading-relaxed border-l-2 border-brand pl-3"
          >
            {error}
          </p>
          <button
            data-testid="auth-callback-back-to-login"
            onClick={() => {
              window.history.replaceState(null, "", "/login");
              navigate("/login", { replace: true });
            }}
            className="w-full bg-zinc-900 hover:bg-brand text-white px-6 py-3 font-bold uppercase tracking-wider transition-colors"
          >
            Wróć do logowania
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center" data-testid="auth-callback">
        <div className="w-12 h-12 border-4 border-zinc-200 border-t-brand rounded-full animate-spin mx-auto mb-4" />
        <div className="font-label">// Logowanie</div>
        <div className="font-heading font-black text-xl uppercase mt-2">
          Finalizujemy zalogowanie...
        </div>
      </div>
    </div>
  );
}
